<template>
	<div
		class="notification-mobile"
		:class="{ open: Boolean(route.query.isInterestMenuOpen) && !displayStore.isDesktop }"
	>
		<MobileSubHeader />
		<div class="search_body c_inner mobile">
			<InterestStockMenu />
		</div>
	</div>
</template>

<script setup lang="ts">
// component
import { onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

import MobileSubHeader from '@/components/layout/header/MobileSubHeader.vue';
import { useDisplayStore } from '@/stores/display';

import InterestStockMenu from './InterestStockMenu.vue';
// -----variable-----
const displayStore = useDisplayStore();
const route = useRoute();

// 화면 나갔을 경우, 스크롤 방지 기능 삭제
onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style scoped lang="scss">
.notification-mobile {
	position: fixed;
	float: right;
	top: 0;
	right: 0;
	width: 100%;
	height: 100dvh;
	background-color: var(--color-bg);
	box-shadow: 0.4rem 0.4rem 1.5rem 0rem #5a5a5a;
	&::-webkit-scrollbar {
		display: none;
	}
	overflow-y: auto;
	color: var(--color-base-white);
	.notification_header-mobile {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: var(--space-xx-small);
		width: 100%;
		height: 6.4rem;
		font-size: var(--font-s-large);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.7rem;
		padding: 1.85rem var(--space-large);
		box-shadow: 4px 4px 10px rgb(0, 0, 0, 0.4);
		.btn_back {
			display: flex;
			gap: 0.4rem;
			img {
				width: 2.6rem;
			}
		}
		.notification_quickMenu-mobile {
			display: flex;
			gap: var(--space-x-small);
			.btn_toggle {
				display: flex;
				gap: 0.05rem;
				img {
					width: 2.4rem;
				}
			}
			.btn_home {
				img {
					width: 2.4rem;
					margin-bottom: 2px;
				}
			}
		}
	}
}
.search_body {
	padding: 3.3rem 2rem;
}
</style>
